import { useLanguage } from "@/contexts/LanguageContext";
import ServicePageLayout from "@/components/ServicePageLayout";
import Seo from "@/components/Seo";
import { CLINIC_ID, absoluteUrl } from "@/lib/seo";
import { Mail } from "lucide-react";
import ContactSection from "@/components/ContactSection";
import type { Locale } from "@/content/types";

const ContactPage = ({ locale }: { locale: Locale }) => {
    const { t } = useLanguage();

    // No `features` cards here: they duplicated the Location/Phone/Working
    // Hours headings that ContactSection below already renders.
    const features: never[] = [];

    const ContactHeroIcon = ({ className }: { className?: string }) => (
        <div className={className + " flex items-center justify-center"}>
            <Mail className="w-full h-full" />
        </div>
    );

    const path = `/${locale}/contact`;
    const description = t('contactPageDescription');

    return (
        <>
            <Seo
                title={`${t('contactUs')} | ${t('clinicName')}`}
                description={description}
                path={path}
                locale={locale}
                keywords="contact primero dental clinic, dental clinic nasr city phone, book dentist appointment cairo"
                schema={{
                    "@context": "https://schema.org",
                    "@type": "ContactPage",
                    // `name` was absent; schema.org ContactPage inherits it from
                    // CreativeWork and consumers use it as the node's label.
                    name: `${t('contactUs')} | ${t('clinicName')}`,
                    description,
                    url: absoluteUrl(path),
                    about: { "@id": CLINIC_ID },
                }}
            />

            <ServicePageLayout
                heroTitle={t('contactUs')}
                heroIntro={t('startJourney')}
                features={features}
                icon={ContactHeroIcon}
            >
                <div className="py-10">
                    <ContactSection />
                </div>
            </ServicePageLayout>
        </>
    );
};

export default ContactPage;
